var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 23,
    viewBox: "0 0 195 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5066_6252)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 187.751 -293.569)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 190.088 -291.266)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 192.424 -288.962)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 195.533 -287.442)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 197.87 -285.138)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 200.207 -282.833)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 202.544 -280.529)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 204.881 -278.225)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 206.446 -275.138)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 208.783 -272.834)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 211.119 -270.531)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 213.456 -268.228)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 215.792 -265.924)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 218.128 -263.621)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 220.465 -261.317)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 222.801 -259.014)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 225.138 -256.71)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 227.474 -254.407)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 230.583 -252.887)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 232.92 -250.583)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 235.257 -248.278)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 237.594 -245.974)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 239.159 -242.887)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 241.496 -240.583)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 243.832 -238.28)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 246.168 -235.977)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 249.277 -234.457)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 251.614 -232.152)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 253.952 -229.848)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 256.289 -227.544)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 258.626 -225.24)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 260.191 -222.152)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 262.527 -219.849)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 264.864 -217.545)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 267.2 -215.242)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 269.537 -212.939)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 271.873 -210.635)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 274.209 -208.332)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 276.546 -206.028)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 278.882 -203.725)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 281.219 -201.422)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 284.327 -199.901)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 286.665 -197.597)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 289.001 -195.293)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 291.339 -192.989)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 292.904 -189.901)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 295.24 -187.598)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 297.577 -185.295)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 300.685 -183.774)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 303.022 -181.47)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 305.359 -179.166)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 307.697 -176.862)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 310.034 -174.558)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 311.599 -171.47)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 313.936 -169.167)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 316.272 -166.864)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 318.608 -164.56)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 320.945 -162.257)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 323.281 -159.953)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 325.618 -157.65)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 327.954 -155.347)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 330.291 -153.043)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 332.627 -150.74)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 335.735 -149.219)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 338.072 -146.915)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 340.41 -144.611)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 342.747 -142.307)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 345.084 -140.003)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 346.649 -136.916)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 348.985 -134.612)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 351.322 -132.309)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 353.658 -130.005)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 355.995 -127.702)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 358.331 -125.398)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 361.44 -123.878)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 363.777 -121.574)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 366.114 -119.27)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 368.451 -116.965)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 370.789 -114.661)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 372.354 -111.574)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 374.69 -109.271)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 377.026 -106.967)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 379.363 -104.664)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 381.699 -102.36)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 384.036 -100.057)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 386.372 -97.7534)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 388.708 -95.4502)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 391.045 -93.1465)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 393.381 -90.8433)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 396.49 -89.3228)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 398.827 -87.0186)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 401.164 -84.7148)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 403.501 -82.4106)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 580.654,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 405.838 -80.1064)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 407.404 -77.019)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 409.74 -74.7153)",
    fill: "#6AC45F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 578.455,
    transform: "matrix(0.712118 0.70206 -0.701714 0.712459 412.077 -72.4121)",
    fill: "#6AC45F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5066_6252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData4);
export default __webpack_public_path__ + "static/media/no-data-4.a8a6bb7c53f3be9b574ba8e29b150cd5.svg";
export { ForwardRef as ReactComponent };